// extracted by mini-css-extract-plugin
export default {"infoItem":"ttKOJeJy","info":"eI3RwroQ"};